/*
 * This is not a great general pattern, as it strips the documentation and polymorphic typing from these functions.
 * This should only be used for functions that are common enough so as to be self-documenting.
 */

import { StringTransform, StringTransformOperator } from './core-types';

/** Composes multiple string transformation functions into a single transformation. */
export function compose(...fns: StringTransform[]): StringTransform {
  return (input: string) => {
    let result = input;
    for (const fn of fns) {
      result = fn(result);
    }
    return result;
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function methodToOperator<A extends any[]>(
  fn: (this: string, ...args: A) => string,
): StringTransformOperator<A> {
  return (...args: A) =>
    ($$) =>
      fn.apply($$, args);
}
